import { useEffect, useCallback } from 'react'
import './Modal.css'

const Modal = ({ 
  isOpen, 
  onClose, 
  title,
  children,
  size = 'md',
  showCloseButton = true,
  closeOnBackdrop = true,
  closeOnEscape = true,
  className = ''
}) => {
  const handleEscape = useCallback((e) => {
    if (e.key === 'Escape' && closeOnEscape) {
      onClose()
    }
  }, [onClose, closeOnEscape])

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && closeOnBackdrop) {
      onClose()
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      if (typeof document !== 'undefined' && document.body) {
        document.body.style.overflow = 'hidden'
      }
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      if (typeof document !== 'undefined' && document.body) {
        document.body.style.overflow = ''
      }
    }
  }, [isOpen, handleEscape])

  if (!isOpen) return null

  const classNames = [
    'modal',
    `modal--${size}`,
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classNames}>
      <div className="modal__backdrop" onClick={handleBackdropClick} />
      
      <div className="modal__container">
        <div className="modal__content">
          {(title || showCloseButton) && (
            <div className="modal__header">
              {title && <h2 className="modal__title">{title}</h2>}
              {showCloseButton && (
                <button 
                  className="modal__close" 
                  onClick={onClose}
                  aria-label="Fechar"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              )}
            </div>
          )}
          
          <div className="modal__body">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
